import React from 'react';
import s from '../solution-rate-reviews.scss';
import { FiveStars } from '../solution-rate/solution-rate-charts';
import { Avatar, Text, Box } from '@wix/design-system';
import { useConfigContext } from '../../../../../config-context';

interface IReviewTitleProps {
  name: string;
  userImg?: string;
  publishDate: string;
  rating?: number;
}
export const ReviewTitle = (props: IReviewTitleProps) => {
  const imgSrc = props.userImg || '';
  const { isMobile } = useConfigContext();

  const publishedDate = isMobile
    ? `${dateFormatter(props.publishDate)}`
    : `/ ${dateFormatter(props.publishDate)}`;
  return (
    <Box verticalAlign="top">
      <Avatar
        name={nameToAvatarFormatter(props.name)}
        imgProps={{ src: imgSrc }}
        size={isMobile ? 'size36' : 'size48'}
      />
      <Box
        direction="vertical"
        marginLeft={isMobile ? '12px' : '18px'}
        verticalAlign="top"
      >
        <Box
          className={s.reviewAuthor}
          direction={isMobile ? 'vertical' : 'horizontal'}
          verticalAlign="middle"
        >
          <span property="author" typeof="Person">
            <Text size="small" weight="normal" property="name">
              {`${nameFormatter(props.name)}`}
              &nbsp;
            </Text>
          </span>
          <Text size="small" weight="thin">
            {publishedDate}
          </Text>
        </Box>
        <span property="reviewRating" typeof="Rating">
          <meta property="ratingValue" content={`${props.rating}`} />
        </span>
        {props.rating && <FiveStars starsToFill={props.rating} size={18} />}
      </Box>
    </Box>
  );
};
export const nameFormatter = (name: string): string => {
  const newName = name
    .toLocaleLowerCase()
    .split(' ')
    .map((n) => n.charAt(0).toUpperCase() + n.slice(1))
    .join(' ');
  return newName;
};

export const nameToAvatarFormatter = (name: string): string => {
  return /\s/.test(name) && name
    ? name
    : name.length > 1
    ? `${name.charAt(0)} ${name.charAt(1)}`
    : `${name.charAt(0)} ${name.charAt(0)}`;
};
const dateFormatter = (dateToFormat: string) => {
  const date = new Date(dateToFormat);
  const dateArr = date && date.toString().split(' ');
  const dateString =
    dateArr && dateArr[1] + ' ' + dateArr[2] + ', ' + dateArr[3];
  return dateString;
};
